const updateColumnsFilterList = (columns) =>
  columns.filter((column) => {
    if (!column.filterType) {
      return false;
    }
    return { ...column };
  });

export default updateColumnsFilterList;
